import VAdvDataTable from './VAdvDataTable'

export { VAdvDataTable }
export default VAdvDataTable
